import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import {
  WorkCenterLabel,
  CreateWorkCenterLabelRequest,
  UpdateWorkCenterLabelRequest,
} from '../models/work-center-label.model';

@Injectable({
  providedIn: 'root',
})
export class WorkCenterLabelService {
  constructor(private apiService: ApiService) {}

  getByWorkCenterId(workCenterId: string): Observable<WorkCenterLabel[]> {
    return this.apiService.get<WorkCenterLabel[]>(
      `/WorkCenterLabel/GetByWorkCenterId/${encodeURIComponent(workCenterId)}`,
    );
  }

  create(request: CreateWorkCenterLabelRequest): Observable<WorkCenterLabel> {
    return this.apiService.post<WorkCenterLabel>(
      '/WorkCenterLabel/CreateLabel',
      request,
    );
  }

  update(request: UpdateWorkCenterLabelRequest): Observable<WorkCenterLabel> {
    return this.apiService.put<WorkCenterLabel>(
      '/WorkCenterLabel/UpdateLabel',
      request,
    );
  }

  delete(uid: string): Observable<void> {
    return this.apiService.delete<void>(
      `/WorkCenterLabel/${encodeURIComponent(uid)}`,
    );
  }
}
